/**
 * Home page component.
 */

import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const user_name = user?.google_name || user?.name || user?.email || t('navbar.user');

  return (
    <div>
      <h2 className="mb-3" style={{ fontWeight: 600, color: 'var(--myant-text-primary)' }}>
        {t('home.welcomeBack', { name: user_name })}
      </h2>
      <p style={{ color: 'var(--myant-text-secondary)', marginBottom: '2rem' }}>
        {t('home.selectSection')}
      </p>
      <Card className="mt-4">
        <Card.Body>
          <Card.Title style={{ fontWeight: 600, marginBottom: '1rem' }}>{t('home.quickActions')}</Card.Title>
          <Card.Text style={{ color: 'var(--myant-text-secondary)', marginBottom: '1.5rem' }}>
            {t('home.getStarted')}
          </Card.Text>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            <Button as={Link as any} to="/datasets" variant="primary">
              {t('home.browseDatasets')}
            </Button>
            <Button as={Link as any} to="/orders" variant="secondary">
              {t('home.viewOrders')}
            </Button>
            <Button as={Link as any} to="/profile" variant="outline-primary">
              {t('home.updateProfile')}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
